import { FloatingPortal } from '@floating-ui/react';

type FootprintCursorTooltipProps = Readonly<{
  lines: readonly string[] | null;
  screenX: number;
  screenY: number;
}>;

export default function FootprintCursorTooltip({
  lines,
  screenX,
  screenY
}: FootprintCursorTooltipProps) {
  if (!lines || lines.length === 0) return null;

  return (
    <FloatingPortal>
      <div
        className='pointer-events-none fixed z-50 w-max rounded bg-[#444] px-2 py-1 text-sm leading-snug text-white'
        style={{ left: screenX + 14, top: screenY + 14 }}
      >
        {lines.map((line) => (
          <div key={line}>{line}</div>
        ))}
      </div>
    </FloatingPortal>
  );
}
